import React from 'react';
import {
	InputControl,
} from "formik-chakra-ui";

function InputText(props) {
	const { name, title, placeholder, onChange } = props
	const handleChange = (event) => {
		const selectedValue = event.target.value;
		if (onChange) {
			onChange(selectedValue);
		}
	};
	return (

		<div className="field_section">
			<InputControl inputProps={{ ...props.inputProps, placeholder }} name={name} label={title} onChange={handleChange} style={props.style} isRequired={props.inputProps?.isRequired} />
		</div>

	);
}
export default InputText;